import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const createAccountEmailVerificationSlice = createSelector(
    stateSelector,
    (state) => state.createAccountEmailVerification
);

export const getCreateAccountSendOtpSubmitted = createSelector(
    createAccountEmailVerificationSlice,
    ({ sendOtp }) => sendOtp.submitted
);
export const getCreateAccountSendOtpError = createSelector(
    createAccountEmailVerificationSlice,
    ({ sendOtp }) => sendOtp.error
);
export const getCreateAccountSendOtpSuccess = createSelector(
    createAccountEmailVerificationSlice,
    ({ sendOtp }) => sendOtp.success
);
export const getCreateAccountVerifyOtpSubmitted = createSelector(
    createAccountEmailVerificationSlice,
    ({ verifyOtp }) => verifyOtp.submitted
);
export const getCreateAccountVerifyOtpError = createSelector(
    createAccountEmailVerificationSlice,
    ({ verifyOtp }) => verifyOtp.error
);
export const getCreateAccountVerifyOtpSuccess = createSelector(
    createAccountEmailVerificationSlice,
    ({ verifyOtp }) => verifyOtp.success
);
export const getCreateAccountUnregisteredUserId = createSelector(
    createAccountEmailVerificationSlice,
    ({ unregisteredUserId }) => unregisteredUserId
);
